import { jsxs as i, jsx as e } from "react/jsx-runtime";
import { useTranslation as u } from "react-i18next";
import o from "@mui/material/Box";
import h from "@mui/material/Container";
import s from "@mui/material/Grid";
import n from "@mui/material/Typography";
import { makeStyles as d } from "tss-react/mui";
import p from "../../../../common/Button/Button.js";
import _ from "../../../../common/Image/Image.js";
import { useBusRentalContext as f } from "../../BusRental.context.js";
import x from "./ReservationRequest.style.js";
import b from "../../form/ReservationRequestForm/ReservationRequestForm.js";
const g = d()(x), R = () => {
  const { classes: t } = g(), { t: r } = u(), { submitSuccess: m, hideSubmitSuccess: c } = f(), a = /* @__PURE__ */ i(s, { container: !0, columnSpacing: 3, rowSpacing: 4, children: [
    /* @__PURE__ */ i(s, { item: !0, xs: 12, sx: { textAlign: "center" }, mb: { xs: 3 }, children: [
      /* @__PURE__ */ e(o, { mb: { xs: 2 }, className: t.heading, children: r("get_a_quote") }),
      /* @__PURE__ */ e(n, { variant: "h4", className: t.subHeading, children: r("we’ll_get_back_to_you_in_24_hours") })
    ] }),
    /* @__PURE__ */ e(s, { item: !0, xs: 12, children: /* @__PURE__ */ e(b, {}) })
  ] }), l = /* @__PURE__ */ e(s, { container: !0, children: /* @__PURE__ */ e(s, { item: !0, xs: 12, children: /* @__PURE__ */ i(o, { py: { xs: 2 }, className: t.submitContent, children: [
    /* @__PURE__ */ e(
      _,
      {
        alt: "Check Circle Icon",
        src: "/images/png/check-circle-filled-md.png",
        width: 72,
        height: 72
      }
    ),
    /* @__PURE__ */ i(o, { children: [
      /* @__PURE__ */ e(
        n,
        {
          variant: "h1",
          mb: { xs: 2 },
          className: t.submitTitle,
          children: r("we_have_received_your_quotation_request!")
        }
      ),
      /* @__PURE__ */ e(
        n,
        {
          variant: "h4",
          mb: { xs: 5 },
          className: t.submitDescription,
          children: r("our_team_will_contact_you_within_24_hours")
        }
      ),
      /* @__PURE__ */ e(
        p,
        {
          fullWidth: !0,
          dataTestid: "busRentalAnotherRequestBtn",
          className: t.moreRequestBtn,
          onClick: c,
          children: r("send_another_request?")
        }
      )
    ] })
  ] }) }) });
  return /* @__PURE__ */ e(
    o,
    {
      py: { xs: 6, sm: 10, md: 15 },
      className: t.wrapper,
      id: "reservationForm",
      children: /* @__PURE__ */ e(h, { children: m ? l : a })
    }
  );
}, F = R;
export {
  F as default
};
